import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

//constants

//validators
import { dropDownValidator, emailValidator, emailValidatorWithParameters, phoneNumberValidatorWithParameters } from '../../validators/CustomValidators';
import { hiddenDropDownValueValidator } from '../../validators/CustomValidators';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'

//constants
import { Constants } from '../../constants/Constants';

//components
import { AccountStatementTypeDropdownComponent } from '../../components/DomainData/AccountStatementTypeDropdown.component';

//base
import { BaseControlGroupComponent } from '../../baseclasses/BaseControlGroup.component';
import { RequestInvoiceNumbersComponent } from './RequestInvoiceNumbers.component';

@Component({
    selector: 'my-statement-details',
    templateUrl: './StatementDetails.component.html',
    providers: [{ provide: BaseControlGroupComponent, useExisting: forwardRef(() => StatementDetailsComponent) }]
})
export class StatementDetailsComponent extends BaseControlGroupComponent {

    public form: FormGroup;
    statementInfo: ent.StatementInfo = new ent.StatementInfo();
    request: ent.Request;

    @Input() public showEmailAddressToReceiveStatement: boolean;
    @Input() public showEmailAddressToReceiveStatement2: boolean;
    @Input() public showAccountStatementType: boolean;
    @Input() public showOverallAccountPhoneNumber: boolean;
    @Input() public showSendStatement: boolean;
    @Input() public showSendInvoice: boolean;
    @Input() public showInvoiceNumbers: boolean;
    @Input() public showEmailCopiesTo: boolean;

    @Input() public requireEmailAddressToReceiveStatement: boolean;
    @Input() public requireEmailAddressToReceiveStatement2: boolean;
    @Input() public requireAccountStatementType: boolean;
    @Input() public requireOverallAccountPhoneNumber: boolean;
    @Input() public requireEmailCopiesTo: boolean;

    contactValidations: ent.ContactValidation[] = [];


    @ViewChild(AccountStatementTypeDropdownComponent) public accountStatementTypeDropdownComponent: AccountStatementTypeDropdownComponent;
    @ViewChild(RequestInvoiceNumbersComponent) public requestInvoiceNumbersComponent: RequestInvoiceNumbersComponent;

    setDates() { }

    setRequestInfo(request: ent.Request) {
        this.request = request;
        this.statementInfo = request.StatementInfo;

        this.requestInvoiceNumbersComponent.lineItems = [];
        if (request.RequestInvoiceNumbers) {
            for (var rin of request.RequestInvoiceNumbers) {
                this.requestInvoiceNumbersComponent.lineItems.push(rin);
            }
        }
    }

    constructor(fb: FormBuilder) {
        super();
        let group = {
            'emailAddressToReceiveStatement': '',
            'emailAddressToReceiveStatement2': '',
            'overallAccountPhoneNumber': '',
            'sendStatement': '',
            'sendInvoice': '',
            'invoiceNumbers': '',
            'accountStatementType': '',
            'emailCopiesTo': ''
        };

        this.form = fb.group(group);

    }


    ngOnInit(): void {

        this.domainDataService.getContactValidations({ IncludeInactive: false }).subscribe(x=>{
            this.contactValidations = x;
            
            if (this.requireEmailAddressToReceiveStatement) {
                this.form.controls.emailAddressToReceiveStatement.setValidators([Validators.required, emailValidator]);
            }
            else {
                this.form.controls.emailAddressToReceiveStatement.setValidators(emailValidator);
            }
            if (this.requireEmailAddressToReceiveStatement2) {
                this.form.controls.emailAddressToReceiveStatement2.setValidators([Validators.required, emailValidator]);
            }
            else {
                this.form.controls.emailAddressToReceiveStatement2.setValidators(emailValidator);
            }
            if (this.showEmailCopiesTo) {
                if (this.requireEmailCopiesTo) {
                    this.form.controls.requireEmailCopiesTo.setValidators([Validators.required, emailValidator]);
                }
                else {
                    this.form.controls.requireEmailCopiesTo.setValidators(emailValidator);
                }
            }
            
            if (this.showOverallAccountPhoneNumber) {
                if (this.requireOverallAccountPhoneNumber) {
                    this.form.controls.overallAccountPhoneNumber.setValidators([Validators.required, phoneNumberValidatorWithParameters(this.contactValidations)]);
                }
                else {
                    this.form.controls.overallAccountPhoneNumber.setValidators(phoneNumberValidatorWithParameters(this.contactValidations));
                }
            }
            

        });
        
        
        
        
        if (this.requireAccountStatementType) {
            this.form.controls.accountStatementType.setValidators(Validators.required);
        }
        if (this.requireEmailCopiesTo) {
            this.form.controls.emailCopiesTo.setValidators([Validators.required, emailValidator]);
        }
        else {
            this.form.controls.emailCopiesTo.setValidators(emailValidator);
        }

    }

    accountStatementTypeChange(event: any) {
        this.statementInfo.AccountStatementTypeID = event;

        var ast = this.accountStatementTypeDropdownComponent.accountStatementTypes.filter(x => x.ID == event)[0];
        if (ast && ast.Name.toUpperCase().includes("EMAIL")) {
            this.form.controls.emailAddressToReceiveStatement.setValidators([Validators.required, emailValidator]);
        }
        else {
            if (this.requireEmailAddressToReceiveStatement) {
                this.form.controls.emailAddressToReceiveStatement.setValidators([Validators.required, emailValidator]);
            }
            else {
                this.form.controls.emailAddressToReceiveStatement.setValidators(emailValidator);
            }
        }

        this.form.controls.emailAddressToReceiveStatement.updateValueAndValidity();
    }

    showRequestInvoiceNumbers(): boolean {
        return this.statementInfo.SendInvoice === true;
    }

    isFieldValid(fieldName: string){
        var val = true;
        var form = this.form;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.invalid){
                val = false;
            }
        }
        return val;
    }

    getCustomError(fieldName: string) : string{
        
        if (!this.isFieldValid(fieldName)) {
            return "";
        }
        var form = this.form;
        if (form.controls[fieldName].errors){
            if (form.controls[fieldName].errors.customError){
                return form.controls[fieldName].errors.customError;
            }
        }
        return "";
    }

}